module.exports = __webpack_public_path__ + "img/HeavierThan5kg-gray.c0d4fd53.svg";